"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT_CANCELED_STATUSES = exports.CANCELED_STATUSES = exports.PAID_STATUSES = exports.PENDING_PAYMENT_STATUSES = exports.READY_TO_SHIP_STATUSES = void 0;
const enums_1 = require("../enums");
exports.READY_TO_SHIP_STATUSES = [
    enums_1.OrderStatus.PartiallyShipped,
    enums_1.OrderStatus.ReadyToShip,
    enums_1.OrderStatus.RetryToShip,
    enums_1.OrderStatus.Unshipped,
];
exports.PENDING_PAYMENT_STATUSES = [
    enums_1.OrderStatus.Authorized,
    enums_1.OrderStatus.PendingPayment,
    enums_1.OrderStatus.PaymentFailed,
    enums_1.OrderStatus.PartiallyPaid,
    enums_1.OrderStatus.ProcessingPayment,
];
exports.PAID_STATUSES = [
    enums_1.OrderStatus.Completed,
    enums_1.OrderStatus.PartiallyPaid,
    enums_1.OrderStatus.Shipped,
    enums_1.OrderStatus.ReadyToShip,
    enums_1.OrderStatus.RetryToShip,
    enums_1.OrderStatus.PartiallyShipped,
    enums_1.OrderStatus.Shipping,
    enums_1.OrderStatus.Unshipped,
];
exports.CANCELED_STATUSES = [
    enums_1.OrderStatus.Canceled,
    enums_1.OrderStatus.Cancelling,
    enums_1.OrderStatus.Invalid,
    enums_1.OrderStatus.PartiallyRefunded,
    enums_1.OrderStatus.PendingCancellation,
    enums_1.OrderStatus.Refunded,
    enums_1.OrderStatus.Refunding,
    enums_1.OrderStatus.Unfulfilled,
];
exports.NOT_CANCELED_STATUSES = Object.keys(enums_1.OrderStatus)
    .map((key) => {
    const status = enums_1.OrderStatus[key];
    if (!exports.CANCELED_STATUSES.includes(status))
        return status;
    return [];
})
    .flat();
//# sourceMappingURL=status-grouping.js.map